import { useSelector } from 'react-redux'
import { MenuItem, MenuList } from '@mui/material'
import {
  type AppointmentEventType,
  type Constant,
  PuiPopper,
  type PuiPopperProps,
  Utils,
} from '@pbt/pbt-ui-components'

import AppointmentStateLabel from '~/components/common/labels/AppointmentStateLabel'
import { getEventType } from '~/store/reducers/constants'
import { useFilteredAppointmentStatuses } from '~/utils/appointmentStatusUtils'

interface StatusSelectActionPopperProps {
  anchorEl: PuiPopperProps['anchorEl']
  onClick: (value: Constant) => void
  onClose: PuiPopperProps['onClose']
}

const StatusSelectActionPopper = ({
  anchorEl,
  onClick,
  onClose,
}: StatusSelectActionPopperProps) => {
  const EventType = useSelector(getEventType)
  const AppointmentEvent: AppointmentEventType =
    Utils.findConstantByName('Appointment', EventType) || {}

  const filteredStatuses = useFilteredAppointmentStatuses(
    AppointmentEvent.states,
  )

  return (
    <PuiPopper
      hideCloseButton
      anchorEl={anchorEl}
      modifiers={[
        {
          name: 'offset',
          options: {
            offset: [0, 10],
          },
        },
      ]}
      open={Boolean(anchorEl)}
      placement="right-start"
      onClose={onClose}
    >
      <MenuList disableListWrap>
        {filteredStatuses.map((state) => (
          <MenuItem key={state.id} onClick={() => onClick(state)}>
            <AppointmentStateLabel item={{ state }} />
          </MenuItem>
        ))}
      </MenuList>
    </PuiPopper>
  )
}

export default StatusSelectActionPopper
